
/* eslint-disable */
import {
  LOGIN_SUCCESS,
  SHOW_TOAST,
  LOGIN,
  LOG_OUT,
  CLEAR_URERINFO,
  SET_LOADING,
  CLEAR_TABS,
  GET_SHORTCUT,
  READ_TOKEN
} from '../types'

import global from './global'
import {login, readToken} from '../../api'
import authService from '../../utils/authService'
/* eslint-enable */
const authModule = {
  state: {
    userInfo: null,
    wust: null,
    rwCondition: null
  },
  mutations: {
    [LOGIN_SUCCESS] (state, payload) {
      console.log(payload)
      state.userInfo = payload.userInfo
      state.wust = payload.wust
      state.rwCondition = payload.rwCondition
    },
    [CLEAR_URERINFO] (state) {
      state.token = null
      state.userInfo = null
      state.rwCondition = null
      // window.localStorage.removeItem('Email')
      // window.localStorage.removeItem('LenovoID')
      window.localStorage.clear()
      // window.localStorage.removeItem('ico')
      // window.localStorage.removeItem('name')
      // window.localStorage.removeItem('shortcutId')
    }
  },
  actions: {
    // [LOGIN] ({commit, dispatch}, auth) {
    //   if (!auth.email || !auth.password) {
    //     dispatch(SHOW_TOAST, '输入不能为空')
    //     return
    //   }
    //   commit(SET_LOADING, 50)
    //   login(auth.email, auth.password).then((res) => {
    //     commit(SET_LOADING, 80)
    //     if (res.data.code === '0') {
    //       console.log('login successfully')
    //       authService.saveCookie('token', res.data.data.accessToken)
    //       window.localStorage.setItem('ico', res.data.data.ico)
    //       window.localStorage.setItem('name', res.data.data.name)
    //       window.localStorage.setItem('shortcutId', (res.data.data.userId + 'shortcut'))
    //       let payload = {
    //         token: res.data.data.accessToken,
    //         userInfo: res.data.data
    //       }
    //       commit(SET_LOADING, 100)
    //       commit(LOGIN_SUCCESS, payload)
    //       commit(GET_SHORTCUT, payload.userInfo)
    //       dispatch(SHOW_TOAST, '登录成功')
    //       window.router.replace('/home')
    //     } else {
    //       commit(SET_LOADING, 100)
    //       dispatch(SHOW_TOAST, res.data.message)
    //     }
    //   }, (res) => {
    //     commit(SET_LOADING, 100)
    //     dispatch(SHOW_TOAST, '登录失败')
    //   })
    // },
    [LOG_OUT] ({commit}) {
      authService.signOut()
      // window.router.replace('/login')
      // commit(CLEAR_TABS)
      commit(CLEAR_URERINFO)
    },
    [READ_TOKEN] ({commit, dispatch}, para) {
      readToken(para.wust).then(res => { handleData(res) }, res => {
        dispatch(SHOW_TOAST, 'login failed')
      })
      function handleData (res) {
        console.log(res.data)
        if (res.data.code === '0') {
          console.log('login successfully')
          authService.saveCookie('wust', res.data.data.wust)
          authService.saveCookie('LenovoID.num', res.data.data.LenovoID)
          authService.saveCookie('Email', res.data.data.Email)
          // authService.saveCookie('rwCondition', res.data.data.resRow.rwCondition)
          let payload = {
            wust: res.data.data.wust,
            userInfo: res.data.data,
            rwCondition: res.data.data.resRow.rwCondition
          }
          window.localStorage.setItem('Email', res.data.data.Email)
          window.localStorage.setItem('LenovoID', res.data.data.LenovoID)
          // window.localStorage.setItem('rwCondition', res.data.data.resRow.rwCondition)
          commit(LOGIN_SUCCESS, payload)
          window.location.href = '/'
          // window.router.replace('/home') not this for we need to get rid of those URL parameter
        } else if (res.data.code === '0000003') {
          window.router.replace('/unAuth')
        } else {
          dispatch(SHOW_TOAST, res.data.message)
        }
      }
    }
  },
  getters: {
  }
}
export default authModule



// WEBPACK FOOTER //
// ./src/store/modules/auth.js